
export interface AppConstants {
  polandCountryId: number;
  localStorageConstants: LocalStorageConstants;
}

export interface LocalStorageConstants {
  isAfterWizard: string;
  isLogout: string;
  isRedirectFromMyInterviews: string;
  selectedLanguage: string;
}

const appConstants: AppConstants = {
  polandCountryId: 1,
  localStorageConstants: {
    isAfterWizard: 'is-after-wizard',
    isLogout: 'isLogout',
    isRedirectFromMyInterviews: 'isRedirectFromMyInterviews',
    selectedLanguage: 'selected-language'
  }
};

export const AppConstants: AppConstants = appConstants;
